exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.video-input .well.selected {\n   background-color: #00588d;\n}\n.video-input .well.selected .media-heading {\n   color: #fff;\n}\n.video-input .video-list {\n   height: 400px;\n   overflow-y: auto;\n}\n", ""]);

// exports
